const defaultWait = (milliseconds) => new Promise((resolve) => {
  setTimeout(resolve, milliseconds);
});

export const waitForActiveSubscription = async ({
  checkSubscription,
  attempts = 10,
  intervalMs = 1000,
  wait = defaultWait,
}) => {
  let lastSubscription = null;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      lastSubscription = await checkSubscription();
      if (lastSubscription?.status === 'active') {
        return {
          state: 'success',
          subscription: lastSubscription,
        };
      }
    } catch {
      // Stripe webhooks and the confirmation endpoint can briefly race after
      // the browser returns. Retry before showing the slower-processing state.
    }

    if (attempt < attempts - 1) {
      await wait(intervalMs);
    }
  }

  return {
    state: 'pending',
    subscription: lastSubscription,
  };
};

export const confirmSubscriptionAfterPayment = async ({
  getSubscription,
  confirmSubscription,
  attempts = 10,
  intervalMs = 1000,
  wait = defaultWait,
}) => {
  try {
    const currentSubscription = await getSubscription();
    if (currentSubscription?.status === 'active') {
      return {
        state: 'success',
        subscription: currentSubscription,
      };
    }
  } catch {
    // A transient status-read failure should not prevent the authenticated
    // Stripe reconciliation below from confirming the payment.
  }

  return waitForActiveSubscription({
    checkSubscription: confirmSubscription,
    attempts,
    intervalMs,
    wait,
  });
};

export const removePaymentResultFromUrl = (href) => {
  const url = new URL(href);
  url.searchParams.delete('payment');
  return `${url.pathname}${url.search}${url.hash}`;
};